var _circle, _path;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgCloseCircle = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 7.5,
    fill: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.19375 5.19373C4.93544 5.45204 4.93544 5.87084 5.19375 6.12915L7.06463 8.00003L5.19373 9.87093C4.93542 10.1292 4.93542 10.548 5.19373 10.8064C5.45204 11.0647 5.87084 11.0647 6.12915 10.8064L8.00005 8.93545L9.87084 10.8062C10.1291 11.0645 10.5479 11.0645 10.8063 10.8062C11.0646 10.5479 11.0646 10.1291 10.8063 9.87082L8.93547 8.00003L10.8062 6.12926C11.0645 5.87096 11.0645 5.45216 10.8062 5.19385C10.5479 4.93554 10.1291 4.93554 9.87082 5.19385L8.00005 7.06462L6.12917 5.19373C5.87086 4.93542 5.45206 4.93542 5.19375 5.19373Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCloseCircle, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/close-circle.398797a7.svg";
export { ForwardRef as ReactComponent };